export default "__VITE_ASSET__CoqHG_MM__"